// Importing necessary libraries, action types, and helper functions
import * as types from "./ActionTypes"; // Importing action type constants
import { post, get, put } from "../Helper/index"; // Helper functions for API calls
import * as urls from "../../Uintls/Urls"; // Importing API endpoint URLs

// Action to register a new role
export const roleRegistration = data => dispatch => {
  dispatch({ type: types.ROLE_REGISTRATION_CALL }); // Dispatch action to indicate role registration call
  post({
    url: urls.ROLE_LIST_URL, // API endpoint for role registration
    success: types.ROLE_REGISTRATION_SUCCESS, // Action type for successful registration
    failure: types.ROLE_REGISTRATION_ERROR, // Action type for failed registration
    dispatch, // Dispatch function
    body: {
      ClientID: localStorage.getItem("clientId"), // Client ID from localStorage
      profileCode: data.Profile_Code, // Profile code for the role
      RoleName: data.RoleName, // Name of the role
      LandingPageId: data.LandingPageId, // Landing page ID for the role
      CloneId: data.CloneId, // Clone ID for duplicating an existing role
      Description: data.Description, // Description of the role
      Accessible_Provider: data.accessible, // Accessible providers for the role
    },
  });
};

// Action to update an existing role
export const updateRoleRegistration = (data, id) => dispatch => {
  dispatch({ type: types.ROLE_REGISTRATION_CALL }); // Dispatch action to indicate role update call
  put({
    url: urls.ROLE_LIST_URL, // API endpoint for updating roles
    success: types.ROLE_REGISTRATION_SUCCESS, // Action type for successful update
    failure: types.ROLE_REGISTRATION_ERROR, // Action type for failed update
    dispatch, // Dispatch function
    body: {
      role_Id: id, // Role ID to update
      Profile_Code: data.Profile_Code, // Profile code for the role
      RoleName: data.RoleName, // Name of the role
      LandingPageId: data.LandingPageId, // Landing page ID for the role
      Description: data.Description, // Description of the role
      Accessible_Provider: data.accessible, // Accessible providers for the role
    },
  });
};

// Action to fetch the list of roles
export const getRoleList = () => dispatch => {
  const data = {
    ClientId: localStorage.getItem("clientId"), // Client ID from localStorage
    LoginEmail: localStorage.getItem("email"), // Login email from localStorage
  };
  dispatch({ type: types.ROLE_LIST_CALL }); // Dispatch action to indicate role list fetch call
  get({
    url: `${urls.ROLE_LIST_URL}`, // API endpoint for fetching roles
    success: types.ROLE_LIST_SUCCESS, // Action type for successful fetch
    failure: types.ROLE_LIST_ERROR, // Action type for failed fetch
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

// Action to fetch role permissions
export const rolePermisstionRequest = (data, typed) => dispatch => {
  const finalData = {
    ...data,
    ClientId: JSON.stringify(localStorage.getItem("clientId")), // Client ID from localStorage
    LoginEmail: localStorage.getItem("email"), // Login email from localStorage
  };
  dispatch({ type: types.SET_ROLL_PERMISSIONS_CALL }); // Dispatch action to indicate role permissions fetch call
  get({
    url: `${urls.ROLE_PAGE_PERMISSION}`, // API endpoint for role permissions
    success:
      typed === "admin"
        ? types.SET_ROLE_DETAILS_DATA
        : types.SET_ROLL_PERMISSIONS_SUCCESS,
    failure: types.SET_ROLL_PERMISSIONS_ERROR,
    dispatch,
    body: finalData,
  });
};

// Action to fetch lookup master data
export const lookupMasterRequest = data => dispatch => {
  const finalData = {
    ...data,
  };
  dispatch({ type: types.SET_LOOKUP_MASTER_CALL });
  get({
    url: `${urls.LOOKUP_MASTER_CALL}`,
    success: types.SET_LOOKUP_MASTER_SUCCESS,
    failure: types.SET_LOOKUP_MASTER_ERROR,
    dispatch,
    body: finalData,
  });
};

// Action to update role permissions
export const updateRolePermisstionRequest = data => dispatch => {
  dispatch({ type: types.UPDATE_ROLL_PERMISSIONS_CALL }); // Dispatch action to indicate role permissions update call
  put({
    url: urls.ROLE_PAGE_PERMISSION, // API endpoint for updating role permissions
    success: types.UPDATE_ROLL_PERMISSIONS_SUCCESS, // Action type for successful update
    failure: types.UPDATE_ROLL_PERMISSIONS_ERROR, // Action type for failed update
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

// Action to fetch profile type list
export const getProfileTypeList = data => dispatch => {
  const value = { profileCode: data }; // Profile code for the request
  dispatch({ type: types.PROFILE_TYPE_LIST_CALL }); // Dispatch action to indicate profile type list fetch call
  get({
    url: urls.COMMON_PROFILE_URL, // API endpoint for profile types
    success: types.PROFILE_TYPE_LIST_SUCCESS, // Action type for successful fetch
    failure: types.PROFILE_TYPE_LIST_ERROR, // Action type for failed fetch
    dispatch, // Dispatch function
    body: value, // Request body
  });
};

// Action to fetch landing page list
export const getLandingPageList = data => dispatch => {
  const value = {
    profileCode: data,
  };
  dispatch({ type: types.LANDING_PAGE_LIST_CALL });
  get({
    url: urls.LANDING_PAGE_LIST_URL, // API endpoint for landing pages
    success: types.LANDING_PAGE_LIST_SUCCESS, // Action type for successful fetch
    failure: types.LANDING_PAGE_LIST_ERROR, // Action type for failed fetch
    dispatch, // Dispatch function
    body: value, // Request body
  });
};

// Action to change the role form mode
export const changeRoleFormMode = data => ({
  type: types.ROLE_FORM_MODE, // Action type for changing role form mode
  data, // New form mode data
});

// Action to fetch role details by ID
export const getRoleDetailsById = data => dispatch => {
  const value = {
    roleId: data, // Role ID for the request
    ClientId: localStorage.getItem("clientId"), // Client ID from localStorage
    LoginEmail: localStorage.getItem("email"), // Login email from localStorage
  };
  dispatch({ type: types.ROLE_LIST_BY_ID_CALL }); // Dispatch action to indicate role details fetch call
  get({
    url: urls.GET_ROLE_LIST_BY_ID, // API endpoint for role details
    success: types.ROLE_LIST_BY_ID_SUCCESS, // Action type for successful fetch
    failure: types.ROLE_LIST_BY_ID_ERROR, // Action type for failed fetch
    dispatch, // Dispatch function
    body: value, // Request body
  });
};

// Action to fetch roles by filter data
export const getRoleByFilterData = data => dispatch => {
  const finalData = {
    ...data,
    ClientId: JSON.stringify(localStorage.getItem("sendApiClientId")), // Client ID from localStorage
    LoginEmail: localStorage.getItem("email"), // Login email from localStorage
  };
  dispatch({ type: types.ROLE_LIST_BY_FILTERDATA_CALL }); // Dispatch action to indicate filtered roles fetch call
  get({
    url: `${urls.ROLE_LIST_BY_SEARCH_URL}`, // API endpoint for filtered roles
    success: types.ROLE_LIST_BY_FILTERDATA_SUCCESS, // Action type for successful fetch
    failure: types.ROLE_LIST_BY_FILTERDATA_ERROR, // Action type for failed fetch
    dispatch, // Dispatch function
    body: finalData, // Request body
  });
};

// Action to update role status
export const roleStatusUpdate = data => dispatch => {
  dispatch({ type: types.ROLE_STATUS_UPDATE_CALL }); // Dispatch action to indicate role status update call
  get({
    url: `${urls.ROLE_STATUS_UPDATE_URL}`, // API endpoint for updating role status
    success: types.ROLE_STATUS_UPDATE_SUCCESS, // Action type for successful update
    failure: types.ROLE_STATUS_UPDATE_ERROR, // Action type for failed update
    dispatch, // Dispatch function
    body: data, // Request body
  });
};

// Action to set role search data
export const setRoleSearchData = data => ({
  type: types.ADD_ROLLS_SEARCH_DATA, // Action type for setting role search data
  data, // Search data
});
